import ModalV2 from "@/js/components/ModalV2/ModalV2";
import { __ } from "@/utils/Trans";
import Button from '@/js/components/Buttons/Button';
import adminStore from "@/js/modules/admin/store/AdminStore";

interface IBlokPostModal {
	open: boolean;
	onClose: () => void;
	onSuccess: () => void;
	user: any
}

export default function DeleteUserModal({ onClose, onSuccess, open, user }: IBlokPostModal) {

	const handleSubmit = async () => {
		if (user) {
			await adminStore.deleteUser(user.id)
			if(user.blokId){
				await adminStore.setBlokDeclined(user.blokId)
			}
			onSuccess()
		}
		onClose();
	};

	return (
		<>
			<ModalV2
				open={open}
				onClose={onClose}
				title={"Kullanıcıyı Sil"}
			>
				<div className="max-h-[300px] min-h-[120px] h-full w-full text-left px-4 text-base text-gray-700">
					Bu işlem geri alınamaz. Kullanıcıya ait <strong>Member</strong> ve <strong>Talent</strong> hesapları kalıcı olarak silinecektir.
					<br />
					Silme işlemi log kayıtlarına <strong>otomatik olarak</strong> eklenecektir.
				</div>
				<div className="flex md:justify-end justify-center mt-4">
					<Button
						name={'deleteUserButton'}
						attrs={{ onClick: handleSubmit }}
						classes={'w-full md:w-auto bg-red-600 hover:bg-red-700 text-white'}
					>
						{"Sil"}
					</Button>
				</div>
			</ModalV2>
		</>

	)
}
